import { useState, useEffect, Fragment } from 'react'
import { getUserData, isAuthenticated } from '../utils/auth';
import { apiRequest, getPayment, getUserCredits, trickleCreateObject, trickleListObjects, trickleUpdateObject } from '../utils/api';
import SubscriptionForm from '../components/payments/SubscriptionForm';
import CheckoutForm from '../components/payments/CheckoutForm';

import {loadStripe} from '@stripe/stripe-js';

function PaymentResult() {

    const subscriptionPlans = [
        { id: 'price_basic', name: '基本方案', amount: 9.99, credits: 100, period: '月' },
        { id: 'price_pro', name: '專業方案', amount: 19.99, credits: 250, period: '月' },
        { id: 'price_premium', name: '高級方案', amount: 39.99, credits: 600, period: '月' }
    ];
    const [selectedTab, setSelectedTab] = useState('oneTime');
    const [amount, setAmount] = useState('0');
    const [isSuccess, setIsSuccess] = useState(false);
    const [paymentResult, setPaymentResult] = useState(null);
    const [isProcessing, setIsProcessing] = useState(true);
    const [error, setError] = useState('');
    const [showPaymentForm, setShowPaymentForm] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(subscriptionPlans[0]);
        
    useEffect(() => {
        // Check authentication
        if (!isAuthenticated()) {
            window.location.href = '/auth';
            return;
        }

        const getPaymentResult = async (id) => {
            try {
                setIsProcessing(true);
                const payment = await getPayment(id);
                if (payment.status == 1) {
                    setIsSuccess(true);
                    setAmount(payment.pay_amount);
                }
            } catch {
                console.error('Failed to process payment success:', error);
                setError('處理付款成功後發生錯誤，但您的付款已經完成。請聯繫客服以確認點數是否已添加。');
            } finally {
                setIsProcessing(false);
            }

        }
        const params = new URLSearchParams(window.location.search);
        const orderId = params.get('order_id');
        if (orderId) {
            getPaymentResult(orderId);
        }
    }, []);
    

    return (
        <div className="container mx-auto px-4 py-8" data-name="payment-page">
            <div className="max-w-3xl mx-auto">
                <h1 className="text-3xl font-bold mb-8 text-center">購買點數</h1>
                
                { isProcessing ? <div className="flex justify-center items-center h-64" data-name="loading">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500"></div>
                    </div> : (
                    isSuccess ?
                        <div className="bg-white rounded-xl shadow-lg overflow-hidden p-8 text-center" data-name="success-message">
                            <div className="mb-6 text-green-500">
                                <i className="fas fa-check-circle text-6xl"></i>
                            </div>
                            <h2 className="text-2xl font-bold mb-2">謝謝您！</h2>
                            <p className="text-xl mb-6">您的付款已成功。</p>
                            <p className="mb-6 text-gray-600">
                                {selectedTab === 'oneTime' ? (
                                    <span>您已添加 <strong>{Math.floor(parseFloat(amount) * 10)} 點數</strong> 到您的帳戶。</span>
                                ) : (
                                    <span>您已成功訂閱 <strong>{selectedPlan.name}</strong>。</span>
                                )}
                            </p>
                            <div className="flex justify-center space-x-4">
                                <button
                                    onClick={() => window.location.href = '/workflow'}
                                    className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                                    data-name="go-to-tools"
                                >
                                    開始使用工具
                                </button>
                                <button
                                    onClick={() => window.location.href = '/payment'}
                                    className="px-6 py-2 border border-gray-300 rounded hover:bg-gray-50"
                                    data-name="make-another-payment"
                                >
                                    再次購買
                                </button>
                            </div>
                        </div> :
                        <div className="container mx-auto px-4 py-8 text-center">
                            <div className="bg-red-100 p-6 rounded-lg">
                                <h2 className="text-xl font-bold text-red-700 mb-2">付款未完成</h2>
                                <p>暫未接收到您的付款信息，請稍後再試或者聯絡客服人員！</p>
                                <button
                                    onClick={() => window.location.reload()}
                                    className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                                >
                                    重新載入頁面
                                </button>
                            </div>
                        </div>
                    )
                }
                
                <div className="mt-8 bg-gray-50 p-6 rounded-lg border border-gray-200" data-name="payment-info">
                    <h3 className="text-lg font-medium mb-4">付款資訊</h3>
                    <div className="space-y-4">
                        <div className="flex items-center">
                            <i className="fas fa-lock text-gray-500 mr-3"></i>
                            <p className="text-gray-600">您的付款資訊受到加密和安全保護。</p>
                        </div>
                        <div className="flex items-center">
                            <i className="fas fa-credit-card text-gray-500 mr-3"></i>
                            <p className="text-gray-600">我們接受所有主要的信用卡和借記卡。</p>
                        </div>
                        <div className="flex items-center">
                            <i className="fas fa-question-circle text-gray-500 mr-3"></i>
                            <p className="text-gray-600">
                                需要幫助？<a href="/contact" className="text-blue-600 hover:underline">聯繫我們的支援團隊</a>。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PaymentResult;